export function linesOverlap(lineStart1, lineEnd1, lineStart2, lineEnd2) {
  var overlap = false;
  if (lineStart1 < lineStart2) {
    if (lineEnd1 >= lineStart2) overlap = true;
  } else {
    if (lineStart1 <= lineEnd2) overlap = true;
  }

  return overlap;
}
